import api from './api';

export interface Socio {
  id?: number;
  codigo?: string;
  nome_completo: string;
  cpf: string;
  rg?: string;
  data_nascimento?: string;
  telefone?: string;
  email?: string;
  acesso_todos?: boolean;
  endereco?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
  cr?: string;
  observacoes?: string;
  data_cadastro?: string;
  data_valido_ate?: string;
  data_vencimento_anualidade?: string;
  status?: string;
}

export interface SocioCreate extends Omit<Socio, 'id' | 'codigo' | 'data_cadastro'> {}

export const socioService = {
  async listar(params?: {
    skip?: number;
    limit?: number;
    status?: string;
    busca?: string;
  }): Promise<Socio[]> {
    const response = await api.get<Socio[]>('/api/socios/', { params });
    return response.data;
  },

  async obter(id: number): Promise<Socio> {
    const response = await api.get<Socio>(`/api/socios/${id}`);
    return response.data;
  },

  async criar(socio: SocioCreate): Promise<Socio> {
    const response = await api.post<Socio>('/api/socios/', socio);
    return response.data;
  },

  async atualizar(id: number, socio: Partial<Socio>): Promise<Socio> {
    const response = await api.put<Socio>(`/api/socios/${id}`, socio);
    return response.data;
  },

  async deletar(id: number): Promise<void> {
    await api.delete(`/api/socios/${id}`);
  },
};

